module.exports = __webpack_public_path__ + "img/2018-logo-igarape-vert-branco-PT.f3cb5568.png";